export default __webpack_public_path__ + "static/media/5561275.4a50f048.jpg";